import MainMenu from '@/components/complementarities/main-menu/main-menu.vue'
import ChiefMenu from '@/components/complementarities/chief-menu/chief-menu.vue'
import Menubar from '@/components/complementarities/menubar/menubar.vue'
import * as mutationTypes from '@/store/mutation-types.js'
import icons from '@/mixins/icons.js'
import globalMixin from '@/mixins/global.js'
// import '@/css/main.scss'

import Vue from 'vue'
Vue.mixin(globalMixin)
export default {
  name: 'app',
  components: { MainMenu, Menubar,ChiefMenu  },
  mixins: [icons],
  created () {
    this.$store.commit(mutationTypes.SET_PROJECT_NAAM, 'Schoolware')
  },
  computed: {
    isScreenDisabled () {
      return this.$store.state.flags.screenDisabled
    },
    isScreenLocked () {
      return this.$store.state.flags.screenLocked
    },
    lockedScreenClassIfApplied () {
      let res = this.isDesktopModeOn ? 'desktop-mode-on' : ''
      if (this.$store.state.flags.screenDisabled) {
        // console.log(res + ' disabled-screen')
        return res + ' disabled-screen'
      }
      if (this.$store.state.flags.screenLocked) {
        // console.log(res + ' disabled-screen')
        return res + ' locked-screen'
      }
      return res
    },
    isDesktopModeOn() {
      return false //window.innerWidth > 800 && window.device && window.device.pc
    }
  },
  methods: {
    showMessage () {
      this.$store.commit(mutationTypes.SHOW_MESSAGE, '')
    },
  //   goFS(){
  //     var goFS = document.getElementById("goFS");
  // goFS.addEventListener("click", function() {
  //     document.body.requestFullscreen();
  // }, false);
  //   },
  //   toggleFullScreenEvent(){
  //     var doc = window.document;
  //     var docEl = doc.documentElement;
    
  //     var requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
  //     var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;
    
  //     if(!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
  //       requestFullScreen.call(docEl);
  //     }
  //     else {
  //       cancelFullScreen.call(doc);
  //     }
  //   },
  }
}
